'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define([], function () {
  var AccessibilityFocusHelper = function () {
    function AccessibilityFocusHelper() {
      _classCallCheck(this, AccessibilityFocusHelper);

      this.focusableElements = 'a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
    }

    _createClass(AccessibilityFocusHelper, [{
      key: 'enableElement',
      value: function enableElement(element) {
        if (!element) return;
        element.setAttribute('tabindex', '0');
        element.removeAttribute('aria-hidden');
      }
    }, {
      key: 'disableElement',
      value: function disableElement(element) {
        if (!element) return;
        element.setAttribute('tabindex', '-1');
        element.setAttribute('aria-hidden', 'true');
      }
    }, {
      key: 'enableElements',
      value: function enableElements(elements) {
        var _this = this;

        elements && Array.prototype.slice.call(elements).forEach(function (element) {
          return _this.enableElement(element);
        });
      }
    }, {
      key: 'disableElements',
      value: function disableElements(elements) {
        var _this2 = this;

        elements && Array.prototype.slice.call(elements).forEach(function (element) {
          return _this2.disableElement(element);
        });
      }
    }, {
      key: 'filterFocusable',
      value: function filterFocusable(elements) {
        var _this3 = this;

        return elements && Array.prototype.slice.call(elements).filter(function (element) {
          return _this3.isFocusable(element);
        });
      }
    }, {
      key: 'isFocusable',
      value: function isFocusable(element) {
        var focusableTagNames = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];
        return !!element && (focusableTagNames.includes(element.tagName) || element.getAttribute('tabIndex') === '0');
      }
    }, {
      key: 'focus',
      value: function focus(element) {
        if (!element) return;
        if (!this.isFocusable(element)) {
          element.setAttribute('tabindex', '-1');
          element.addEventListener('blur', function () {
            element.removeAttribute('tabindex');
          });
        }
        element.focus();
      }
    }, {
      key: 'focusAndScroll',
      value: function focusAndScroll(element) {
        this.focus(element);
        element.scrollIntoView();

        var westendHeader = document.querySelector('.westendHeader');
        westendHeader && window.scrollBy(0, -westendHeader.clientHeight);
      }
    }]);

    return AccessibilityFocusHelper;
  }();

  return new AccessibilityFocusHelper();
});
//# sourceMappingURL=accessibilityFocusHelper.js.map
